RivalIQ.apps.Alerts.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.MessageAlert = views.Alert.extend({
        template: '#alertsMessageAlertTemplate',
        getAlertIconClassName: function () {
            const me = this;
            const eventTypeId = me.model.get('event_type_id');
            let source = RivalIQ.utils.eventDisplay.getSource(eventTypeId);
            if (!source) {
                source = me.model.get('data').source;
            }
            const sourceDetails = RivalIQ.enums.sourceDetails[source];
            return sourceDetails.fontIcon;
        },
        augmentTemplateData: function (data) {
            const me = this;

            views.Alert.prototype.augmentTemplateData.apply(me, arguments);

            data.eventTypes = RivalIQ.utils.companyEvents.eventType;

            switch (data.event_type_id) {
                case RivalIQ.utils.companyEvents.eventType.presenceDiscovered:
                case RivalIQ.utils.companyEvents.eventType.presenceGone:
                    data.sourceName = RivalIQ.enums.sourceDetails[data.data.source].name;
                    data.profileUrl = RivalIQ.enums.sourceDetails[data.data.source].profileUrl +
                        data.data.messageData[RivalIQ.enums.sourceDetails[data.data.source].identityType];
                    data.decoratedHandle = (data.data.messageData.handle ?
                        (RivalIQ.enums.sourceDetails[data.data.source].handlePrefix || '') + data.data.messageData.handle : null);
                    break;
                default:
                    throw new Error(`unknown company event type ${data.event_type_id}`);
            }
        }
    });

});
